// extracted by mini-css-extract-plugin
module.exports = {"container":"doctorCreatePatientPage_container__27-eu","title":"doctorCreatePatientPage_title__2FcNf"};